//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SectionMunicipalityEventGrid",
  components: {
    SectionEntityGrid: () => import("@/components/common/SectionEntityGrid")
  },
  computed: {
    ...mapGetters({
      cityId: "municipality/id"
    }),
    eventsGridParams() {
      return {
        city_id: this.cityId,
        started_from: this.$moment().format('YYYY-MM-DD')
      }
    }
  }
};
